import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProofCenterPageDataQueryVariables = Types.Exact<{
  propertyId: Types.Scalars['uuid']['input'];
}>;


export type GetProofCenterPageDataQuery = { __typename?: 'query_root', properties_by_pk: Array<{ __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, photo_link?: string | null, proof_center_status?: string | null, proof_center_about?: string | null, proof_center_headline?: string | null, proof_center_summary?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null }>, proof_center_property_category_requirements: Array<{ __typename?: 'proof_center_property_category_requirements', id: any, is_completed: boolean, pc_category_requirement_id: any }>, properties_subsystems: Array<{ __typename?: 'properties_subsystems', id: any, system_id: any, subsystem: { __typename?: 'subsystems', id: any, name: string, description?: string | null, image?: string | null, date_last_checked?: any | null } }>, proof_center_property_certificates: Array<{ __typename?: 'proof_center_property_certificates', id: any, date_acquired?: any | null, proof_center_certificate: { __typename?: 'proof_center_certificates', label: string, icon: string } }> };


export const GetProofCenterPageDataDocument = gql`
    query getProofCenterPageData($propertyId: uuid!) {
  properties_by_pk: properties(
    where: {id: {_eq: $propertyId}, deleted_at: {_is_null: true}}
  ) {
    id
    name
    address
    address_id
    standardized_address {
      id
      street_1
      street_2
      city
      state
      postal_code
      country
    }
    photo_link
    proof_center_status
    proof_center_about
    proof_center_headline
    proof_center_summary
  }
  proof_center_property_category_requirements(
    where: {property_id: {_eq: $propertyId}}
  ) {
    id
    is_completed
    pc_category_requirement_id
    is_completed
  }
  properties_subsystems(where: {property_id: {_eq: $propertyId}}) {
    id
    system_id
    subsystem {
      id
      name
      description
      image
      date_last_checked
    }
  }
  proof_center_property_certificates(where: {property_id: {_eq: $propertyId}}) {
    id
    date_acquired
    proof_center_certificate {
      label
      icon
    }
  }
}
    `;

/**
 * __useGetProofCenterPageDataQuery__
 *
 * To run a query within a React component, call `useGetProofCenterPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProofCenterPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProofCenterPageDataQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetProofCenterPageDataQuery(baseOptions: Apollo.QueryHookOptions<GetProofCenterPageDataQuery, GetProofCenterPageDataQueryVariables> & ({ variables: GetProofCenterPageDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProofCenterPageDataQuery, GetProofCenterPageDataQueryVariables>(GetProofCenterPageDataDocument, options);
      }
export function useGetProofCenterPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProofCenterPageDataQuery, GetProofCenterPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProofCenterPageDataQuery, GetProofCenterPageDataQueryVariables>(GetProofCenterPageDataDocument, options);
        }
export function useGetProofCenterPageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProofCenterPageDataQuery, GetProofCenterPageDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProofCenterPageDataQuery, GetProofCenterPageDataQueryVariables>(GetProofCenterPageDataDocument, options);
        }
export type GetProofCenterPageDataQueryHookResult = ReturnType<typeof useGetProofCenterPageDataQuery>;
export type GetProofCenterPageDataLazyQueryHookResult = ReturnType<typeof useGetProofCenterPageDataLazyQuery>;
export type GetProofCenterPageDataSuspenseQueryHookResult = ReturnType<typeof useGetProofCenterPageDataSuspenseQuery>;
export type GetProofCenterPageDataQueryResult = Apollo.QueryResult<GetProofCenterPageDataQuery, GetProofCenterPageDataQueryVariables>;